import { ShieldPlusIcon, XIcon } from 'lucide-react'

import { type MedicalPlanDisplayItem } from 'components/member_onboarding_v2/medicalPlanTypes'

import { PlanChip } from '../PlanChip'

export const InNetworkPlansCard: React.FC<{
  plans: MedicalPlanDisplayItem[];
  onRemovePlan: (plan: MedicalPlanDisplayItem) => void;
}> = ({ plans, onRemovePlan }) => {
  return (
    <div className='border rounded-lg border-gray-400 bg-white overflow-hidden'>
      <div className='flex flex-col p-4'>
        <div className='flex gap-1 mb-1'>
          <ShieldPlusIcon size={14} />
          <span className='body-bold'>Plans to check</span>
        </div>
        <span className='body-sm text-gray-500 mb-3'>We can check up to 3 plans for you</span>
        <div className='flex flex-col gap-2'>
          {
            plans.map((planDisplayItem) => {
              const plan = planDisplayItem.plan
              return (
                <div className='p-3 border rounded-lg shadow-sm' key={plan.id}>
                  <div className='flex gap-2 items-center'>
                    <div className='flex-1 border-gray-200 border-r'>
                      <PlanChip
                        carrierLogo={plan.carrier_image_url ?? ''}
                        carrierName={plan.carrier_name}
                        planName={plan.friendly_name}
                      />
                    </div>
                    <button onClick={() => onRemovePlan(planDisplayItem)}>
                      <XIcon size={16} />
                    </button>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}
